export default __webpack_public_path__ + "static/media/Etiketes.a9564792.jpg";